<script>
import { iIcon, iSpinner } from '@inscribe/signal';

import {
  PROCESSING_EVENT_STATUS,
  processingEventStatusToLabel,
  processingEventTypeToLabel,
} from '@/utils/processingEvent';

export default {
  name: 'ProcessingEvent',
  components: {
    iIcon,
    iSpinner,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  computed: {
    isFinished() {
      return this.status === PROCESSING_EVENT_STATUS.FINISHED;
    },
    isInProgress() {
      return this.status === PROCESSING_EVENT_STATUS.IN_PROGRESS;
    },
    isNotStarted() {
      return !this.isFinished && !this.isInProgress;
    },
    titleColorClass() {
      return this.isNotStarted ? 'i-text-neutral-100' : 'i-text-neutral-120';
    },
    typeLabel() {
      return processingEventTypeToLabel(this.type);
    },
    statusLabel() {
      return processingEventStatusToLabel(this.status);
    },
  },
};
</script>

<template>
  <div
    class="analysis-step d-flex align-items-center justify-content-between i-py-4"
  >
    <div class="d-flex align-items-center i-gap-6">
      <!-- Status Icon/Spinner -->
      <i-spinner
        v-if="isNotStarted"
        size="xs"
        class="i-text-primary-110"
        :spinning="false"
      />
      <i-spinner
        v-else-if="isInProgress"
        size="xs"
        class="i-text-primary-110"
      />
      <i-icon
        v-else
        symbol="medium-solid-check-circle"
        class="i-text-primary-110"
        :size="14"
      />

      <span class="i-text-subheading-3" :class="titleColorClass">
        {{ typeLabel }}
      </span>
    </div>

    <span class="i-text-body-3 i-text-neutral-100">
      {{ statusLabel }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.i-icon,
.i-spinner {
  flex-shrink: 0; // Prevent icons/spinner from shrinking
}

.i-spinner {
  padding: 1px;
}
</style>
